
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/nfl-matchups",
      function () {
        return require("private-next-pages/sitemap/nfl-matchups.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/nfl-matchups"])
      });
    }
  